import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/snake-rescue', label: 'Snake Rescue' },
    { path: '/workshops', label: 'Workshops' },
    { path: '/safety-audit', label: 'Safety Audit' },
    { path: '/areas', label: 'Areas We Serve' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/logo-512.png"
                alt="Snake Catchers Bangalore logo"
                className="w-12 h-12 object-contain"
                data-testid="footer-logo-img"
              />
              <div>
                <h3 className="text-lg font-bold">Snake Catchers Bangalore</h3>
                <p className="text-xs text-emerald-400">Experts in Bangalore</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Professional 24/7 snake rescue services in Bangalore by expert snake catchers Alhan Nawaz and Mohan K. We provide safe, humane snake removal and awareness programs.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-emerald-400 text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <div className="space-y-4 mb-4">
              <div>
                <p className="text-emerald-400 font-semibold mb-2">Alhan Nawaz</p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <Phone className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                    <div>
                      <a
                        href="tel:+918310755854"
                        className="text-gray-400 hover:text-emerald-400 transition-colors text-sm"
                      >
                        +91 8310755854
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <MapPin className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-400 text-sm">
                      Babusapalya, Bangalore - 560043
                    </span>
                  </li>
                </ul>
              </div>
              
              <div>
                <p className="text-emerald-400 font-semibold mb-2">Mohan K</p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <Phone className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                    <div>
                      <a
                        href="tel:+919845080903"
                        className="text-gray-400 hover:text-emerald-400 transition-colors text-sm"
                      >
                        +91 9845080903
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-2">
                    <MapPin className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-400 text-sm">
                      Ulsoor, Bangalore - 560008
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="flex items-start gap-2 pt-4 border-t border-gray-800">
              <Clock className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
              <span className="text-gray-400 text-sm">
                24/7 Emergency Service
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Snake Catchers Bangalore. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;